import React, { useState, useEffect } from "react";
import settingService from "../services/setting";
import session from "../services/session";
import { getUrlParam } from "../utils/utils";
import { NavLink, Redirect } from "react-router-dom";
import Switch from "react-switch";
import KeyboardBackspaceIcon from "@material-ui/icons/KeyboardBackspace";
import { swalInfo, swalLoading, swalPkgChange } from "../utils/swal";
import Swal from "sweetalert2";
import userService from "../services/user";
import { Tooltip } from "@material-ui/core";
import { useNavigate } from "react-router-dom";

export default function Setting(props) {
  const navigate = useNavigate();
  const [errorMessage, setErrorMessage] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);
  const [data, setData] = useState(null);
  const [checked, setChecked] = useState(false);
  const [logo, setLogo] = useState(session.get("user")?.logo || null);
  const [logoUploading, setLogoUploading] = useState(false);
  const userPackage = session.get("user")?.package;
  const isPremium = ["3", "5"].includes(String(userPackage));

  useEffect(() => {
    settingService.getEmailNotifications().then((result) => {
      if (result.error) {
        setErrorMessage(result.error);
        setSuccessMessage(null);
        return;
      }

      if (result.data) {
        setErrorMessage(null);
        setChecked(result.data.emailNotifications);
      }
    });
  }, []);

  const handleLogoUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setLogoUploading(true);
    setErrorMessage(null);
    setSuccessMessage(null);

    const result = await userService.uploadLogo(file);
    setLogoUploading(false);

    if (result.error) {
      setErrorMessage(result.error);
      return;
    }

    if (result.data) {
      session.set("user", result.data);
      window.location.reload();
    }
  };

  const handleRemoveLogo = async () => {
    setErrorMessage(null);
    setSuccessMessage(null);

    const result = await userService.removeLogo();

    if (result.error) {
      setErrorMessage(result.error);
      return;
    }

    if (result.data) {
      session.set("user", result.data);
      window.location.reload();
    }
  };

  const handleDeleteAccount = async () => {
    swalPkgChange(
      `Are you sure?`,
      `Once deleted, your account and all associated data will be permanently removed.`,
      `info`,
      async () => {
        await userService.deleteAccount().then((result) => {
          navigate("/login");
          console.log(result);
        });
      }
    );
  };

  const handleCheckChange = (check) => {
    setChecked(check);
    settingService.setEmailNotifications(check).then((result) => {
      if (result.error) {
        setErrorMessage(result.error);
        setSuccessMessage(null);
        return;
      }

      if (result.data) {
        setErrorMessage(null);
        setSuccessMessage(`Setting updated successfully!`);
      }
    });
  };

  return (
    <div className="container" style={{ color: "white" }}>
      <div className="row mt-20 mb-20">
        <div className="col-12">
          <label className="h2">
            <Tooltip title="Back to projects" aria-label="Back to projects">
              <KeyboardBackspaceIcon
                className="material-svg back-button-selector"
                style={{ marginRight: "10px" }}
                onClick={(e) => navigate(`/`)}
              />
            </Tooltip>
            Settings
          </label>
        </div>
      </div>
      <div className="row mt-20 mb-20">
        <div className="col-12">
          <label className="h4">Custom Logo</label>
        </div>
      </div>
      <div className="row">
        <div className="col">
          <small style={{ color: "#878787" }}>
            Upload your own logo to replace the default Filmboard logo in the
            navigation bar.
          </small>
          {isPremium ? (
            <div style={{ marginTop: "15px", display: "flex", alignItems: "center", gap: "20px" }}>
              <div
                style={{
                  width: "100px",
                  height: "35px",
                  backgroundColor: "#1a1a1a",
                  borderRadius: "4px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  border: "1px solid #333",
                  overflow: "hidden",
                }}
              >
                {logo ? (
                  <img
                    src={`${logo}?${new Date().getTime()}`}
                    alt="Custom logo"
                    style={{ maxWidth: "100%", maxHeight: "100%", objectFit: "contain" }}
                  />
                ) : (
                  <img
                    src="../logo.png"
                    alt="Default logo"
                    style={{ maxWidth: "100%", maxHeight: "100%", objectFit: "contain" }}
                  />
                )}
              </div>
              <div style={{ display: "flex", gap: "10px" }}>
                <label
                  htmlFor="logo-upload"
                  style={{
                    padding: "8px 16px",
                    backgroundColor: "#4c72cd",
                    color: "white",
                    borderRadius: "4px",
                    cursor: logoUploading ? "not-allowed" : "pointer",
                    fontSize: "14px",
                    opacity: logoUploading ? 0.6 : 1,
                  }}
                >
                  {logoUploading ? "Uploading..." : "Upload Logo"}
                </label>
                <input
                  id="logo-upload"
                  type="file"
                  accept="image/*"
                  style={{ display: "none" }}
                  onChange={handleLogoUpload}
                  disabled={logoUploading}
                />
                {logo && (
                  <button
                    onClick={handleRemoveLogo}
                    style={{
                      padding: "8px 16px",
                      backgroundColor: "transparent",
                      color: "#ff4d4f",
                      border: "1px solid #ff4d4f",
                      borderRadius: "4px",
                      cursor: "pointer",
                      fontSize: "14px",
                    }}
                  >
                    Remove
                  </button>
                )}
              </div>
            </div>
          ) : (
            <div style={{ marginTop: "15px" }}>
              <p style={{ color: "#888", fontSize: "14px", margin: 0 }}>
                Custom logos are available on the Premium plan.{" "}
                <a href="/billing" style={{ color: "#4c72cd" }}>Upgrade</a>
              </p>
            </div>
          )}
        </div>
      </div>

      <div className="row mt-20 mb-20" style={{ marginTop: "40px" }}>
        <div className="col-12">
          <label className="h4">Email Notifications</label>
        </div>
      </div>
      <div className="row">
        <div className="col">
          <label htmlFor="chk-receive-emails" style={{ marginRight: "20px" }}>
            Receive comment notifications
          </label>
          <Switch
            checked={checked}
            onChange={handleCheckChange}
            onColor="#86d3ff"
            onHandleColor="#2693e6"
            handleDiameter={20}
            uncheckedIcon={false}
            checkedIcon={false}
            boxShadow="0px 1px 5px rGBa(0, 0, 0, 0.6)"
            activeBoxShadow="0px 0px 1px 10px rGBa(0, 0, 0, 0.2)"
            height={15}
            width={48}
            className="react-switch"
            id="chk-receive-emails"
          />
          <br />
          <small style={{ color: "#878787" }}>
            You'll receive email notification when someone comments on your
            board or tags you in a comment.
          </small>
        </div>
      </div>

      <div className="row mt-30">
        <div className="col">
          {errorMessage && <p className="alert alert-danger">{errorMessage}</p>}
          {successMessage && (
            <p className="alert alert-success">{successMessage}</p>
          )}
        </div>
      </div>
      <div className="row">
            <a style={{color:"red"}} onClick={handleDeleteAccount}>
              Delete Account
            </a>
        </div>
    </div>
  );
}
